import { Skeleton, Stack, VisuallyHidden } from '@mantine/core'
import type { MantineSpacing } from '@mantine/core'
import { useReducedMotion } from '@mantine/hooks'

export interface ListSkeletonProps {
    // Number of placeholder rows.
    count?: number
    // Row height in px — match the real row/card it stands in for.
    height?: number
    gap?: MantineSpacing
}

// Loading placeholder for vertical lists and tables: N full-width skeleton bars
// that stand in for the rows/cards about to load. Calmer than a centered spinner
// and it holds the layout so content doesn't jump in. The pulse is disabled
// under prefers-reduced-motion; screen readers hear "Loading" via the live
// region while the bars themselves are decorative.
export function ListSkeleton({
    count = 4,
    height = 72,
    gap = 'sm',
}: ListSkeletonProps) {
    const reducedMotion = useReducedMotion()
    return (
        <Stack component='output' gap={gap} style={{ flex: 1 }} aria-busy>
            <VisuallyHidden>Loading…</VisuallyHidden>
            {Array.from({ length: count }, (_, i) => (
                <Skeleton
                    key={i}
                    height={height}
                    radius='md'
                    animate={!reducedMotion}
                />
            ))}
        </Stack>
    )
}
